module.exports = __webpack_public_path__ + "img/play_color.12032260.svg";